import { ReactNode } from 'react'
import { PackageCopies, Pallets } from '../../../types/api/shipment'
import Shipment from '../../../types/api/shipment'
import { hasDmsInFinishing } from '../../../helpers/is-dms-machine'
import formatIntegerBySpace from '../../../helpers/formatters/format-integer-by-space'

const packageCopiesLabel = (v: PackageCopies | undefined): string => {
    if (v === PackageCopies.Strictly) return 'Строго по заявленному количеству'
    if (v === PackageCopies.NotStrictly) return 'Клиент возьмет больше'
    return v != null ? String(v) : '—'
}

const palletLabel = (v: Pallets | undefined): string => {
    if (v === Pallets.Euro) return 'Евро'
    if (v === Pallets.Any) return 'Любой'
    if (v === Pallets.No) return 'Нет'
    return v != null ? String(v) : '—'
}

const yn = (v: boolean | undefined): string =>
    v === true ? 'Да' : v === false ? 'Нет' : '—'

const windingInfoText = (shipment: Shipment): string => {
    const info = shipment.windingInfo?.trim()
    if (!info) return '—'
    const quantity = formatIntegerBySpace(shipment.quantityPerRoll)
    return quantity ? `${quantity} ${info}` : info
}

const labelingLabel = (manual: boolean | undefined): string => {
    if (manual === true) return 'Ручная'
    if (manual === false) return 'Автоматическая'
    return '—'
}

const clientLabelText = (clientLabel: boolean | undefined): string => {
    if (clientLabel === true) return 'Клиента'
    if (clientLabel === false) return 'Гамма (наш)'
    return '—'
}

export function getShipmentPeopleInfoLines(
    shipment: Shipment
): { label: string; value: string }[] {
    return [
        {
            label: 'Менеджер',
            value: shipment.user_audit?.created_by_permissions_user?.username || '—',
        },
        { label: 'Дизайнер', value: shipment.designer?.username || '—' },
    ]
}

/** Редактируемые значения строк; если не переданы — выводится текст */
export interface ShipmentExtraInfoEditors {
    printWithCurator?: ReactNode
}

export function getShipmentExtraInfoLines(
    shipment: Shipment,
    editors: ShipmentExtraInfoEditors = {}
): { label: string; value: ReactNode }[] {
    const peopleLines = getShipmentPeopleInfoLines(shipment)

    return [
        { label: 'Упаковка', value: shipment.package || '—' },
        { label: 'Тираж упаковки', value: packageCopiesLabel(shipment.packageCopies) },
        { label: 'Инфо по намотке', value: windingInfoText(shipment) },
        { label: 'Этикеровка', value: labelingLabel(shipment.manualLabeling) },
        { label: 'Ярлык', value: clientLabelText(shipment.clientLabel) },
        { label: 'Паллет', value: palletLabel(shipment.pallet) },
        { label: 'Конгрев', value: yn(shipment.congreve) },
        { label: 'Праймировать материал', value: yn(shipment.priming) },
        { label: 'Отделка на DMS', value: yn(hasDmsInFinishing(shipment.additional_machines)) },
        {
            label: 'Втулка',
            value: shipment.bushing != null ? `${shipment.bushing} мм` : '—',
        },
        { label: 'Печать на клеевом слое', value: yn(shipment.printingOnGlueLayer) },
        {
            label: 'Печать с куратором',
            value: editors.printWithCurator ?? yn(shipment.printWithCurator),
        },
        ...peopleLines,
        { label: 'Комментарий', value: shipment.comment || '—' },
    ]
}
